import { divide, multiply, subtract } from "lodash";
import FormulaLayoutUI from "./FormulaLayoutUI";
import { getMinValue } from "../../Regex";

const MillerBrokerageAmount = ({
  millerBrokerageRate,
  // dispatchWeight,
  // netWeight,
  millerBillWeight,
}) => {
  // const nw = getMinValue(
  //   Number(dispatchWeight).toFixed(3),
  //   Number(netWeight).toFixed(3),
  //   Number(millerBillWeight).toFixed(3)
  // );
  const nw = Number(millerBillWeight).toFixed(3)
  console.log(nw, "nw");
  const finalVal = multiply(
    Number(millerBrokerageRate ?? 0),
    nw,
  ).toFixed(2);

  return (
    <FormulaLayoutUI>
      <div style={{ marginBottom: "12px" }}>
        <strong style={{ fontSize: "15px" }}>
          Miller Brokerage Amount Formula
        </strong>
      </div>

      <div
        style={{
          padding: "10px 12px",
          border: "1px solid #e0e0e0",
          borderRadius: "6px",
          fontSize: "13px",
          marginBottom: "10px",
        }}
      >
        <div>
          Brokerage = Miller Brokerage Rate × Miller Bill Weight
        </div>

        <div style={{ marginTop: "6px", color: "#555" }}>
          = {Number(millerBrokerageRate ?? 0)} × {Number(millerBillWeight).toFixed(3)}
        </div>

        <div style={{ marginTop: "6px" }}>
          = {Number(millerBrokerageRate ?? 0)} × {Number(nw).toFixed(3)}
        </div>

        <div
          style={{
            marginTop: "10px",
            fontSize: "15px",
            fontWeight: 600,
          }}
        >
          Brokerage Amount: ₹ {Number(finalVal).toFixed(2)} /-
        </div>
      </div>
    </FormulaLayoutUI>
  );
};

export default MillerBrokerageAmount;
